<template>
  <div class="edit-comment-input">
    <TextEditor id="short-content"
                v-if="users"
                :users="users"
                :on-change="(html, count) => { this.newComment = html; this.charCount = count }"
                :initial-value="newComment"
                :max-length="500"
                :editor-api="(e) => this.editor = e"
    />
    <div class="buttons-container">
      <div class="button-modify-container">
        <v-button :on-click="cancel"
                  :type="'mg-l-5 close'"
                  :height="'30px'"
                  :border-radius="'50px'"
                  :disabled="disableCancel"
        >
          {{ $t('post.commentInput.cancel') }}
        </v-button>
      </div>
      <div class="button-modify-container">
        <v-button :on-click="validate"
                  data-cy="comment-submit"
                  class="modify-comment-button"
                  :disabled="showButton"
                  :is-loading="this.isLoadingF"
                  :height="'30px'"
                  :border-radius="'50px'"
        >
          {{ buttonName }}
        </v-button>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/shared/VButton'
import TextEditor from '../shared/TextEditor/TextEditor'

export default {
  name: 'CommentInput',
  components: { VButton, TextEditor },
  created() {
    this.newComment = this.initializedComment()
    this.newComment = this.insertAttributesToMentions(this.newComment, ' contenteditable="false" data-type="mention" ')

    this.initialComment = this.newComment
    this.charCount = this.newComment.replace(/<[^>]+>/g, '').length
  },
  data() {
    return {
      newComment: '',
      initialComment: '',
      charCount: 0,
      editor: {}
    }
  },
  props: {
    buttonName: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    comment: {
      type: String,
      required: true
    },
    communityId: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  updated() {
    if (this.initialComment !== this.comment) {
      this.initialComment = this.comment
      this.newComment = this.initializedComment()
      this.newComment = this.insertAttributesToMentions(this.newComment, ' contenteditable="false" data-type="mention" ')
      this.charCount = this.newComment.replace(/<[^>]+>/g, '').length
      this.editor.commands.setContent(this.newComment)
    }
  },
  methods: {
    insertAttributesToMentions(str, substring) {
      const indexes = [...this.newComment.matchAll(new RegExp('(?<=<span)(.*?)(?=data-id=)', 'gi'))].map(a => a.index)
      indexes.sort((n1, n2) => n2 - n1)
      let result = str.slice()
      for (let i = 0; i < indexes.length; i++) {
        result = indexes[i] > 0 ? result.slice(0, indexes[i]) + substring + result.slice(indexes[i]) : result
      }
      return result
    },
    validate() {
      this.$emit('send', this.newComment, this.charCount, this.item)
      this.newComment = ''
      this.initialComment = ''
      this.editor.commands.clearContent()
    },
    cancel() {
      this.newComment = ''
      this.editor.commands.clearContent()
      this.$emit('cancel', this.newComment)
    },
    initializedComment() {
      return this.$sanitizeHTML(this.$decodeHTML(this.comment))
    }
  },
  computed: {
    disableCancel() {
      return this.item.id ? false : this.newComment.replace(/<[^>]+>/g, '').length <= 0
    },
    isLoadingF() {
      return this.loading
    },
    showButton() {
      return this.newComment.replace(/<[^>]+>/g, '').length <= 0
    },
    users() {
      return this.$store.getters.userByCommunity[this.communityId]
    }
  }
}
</script>

<style scoped lang="scss">
.edit-comment-input {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (max-width: $small) {
    min-width: auto;
    margin-left: 0;
    width: 100%;
  }

  textarea {
    padding: 10px 10px 0 10px;
    border: solid 1px #c1c1c1;
    border-radius: 3px;
    width: 97%;
    font-size: 15px;
    resize: none;
    margin-bottom: 7px;
    font-family: OpenSans-Regular, sans-serif;

    &::placeholder {
      color: #999999;
    }
  }

  .buttons-container {
    display: flex;
    align-items: center;

      .button-modify-container {
        padding-bottom: 10px;

        @media (max-width: $small) {
          padding-bottom: 0;
        }

      .modify-comment-button {
        height: 32px;
      }
    }

    .cancel {
      color: $primary-color;
      cursor: pointer;
      padding: 0 0 10px 16px;
      font-size: 13px;
    }
  }
}

</style>
